import moment from "moment-timezone";

const { hostname } = window.location;

export const IS_DEV = /local.workstep.com/.test(hostname);
export const IS_DEMO = /demo(-stage)?.workstep.com/.test(hostname);
export const IS_STAGE = !IS_DEMO && /stage.workstep.com/.test(hostname);
export const IS_PROD = !IS_DEV && !IS_STAGE && !IS_DEMO;

export const WAGE_MIN = 11;
export const WAGE_MAX = 40;
export const WAGE_DEFAULT = 11;

export const CALENDAR_CONFIG = {
    WORKDAY_START: moment().set({
        hour: 6,
        minute: 0,
    }),
    WORKDAY_END: moment().set({
        hour: 21,
        minute: 0,
    }),
};

export const MATCH_SCORE_THRESHOLD = 75;

export const MIN_SKILL_DESCRIPTION_LENGTH = 40;

export const STORAGE_KEY = {
    SUMMARY_JOB_PROMO: "summary-job-promo",
};
